import './videos.scss';

const Videos: React.FC = function () {
  return <div>This is a component!</div>;
};

export default Videos;
